import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#09090B] pt-24 flex items-center justify-center px-4" data-testid="payment-cancel-page">
      <div className="max-w-md w-full text-center">
        <XCircle size={44} className="text-zinc-500 mx-auto mb-4" />
        <h1 className="text-2xl md:text-3xl tracking-tight font-medium text-white mb-3" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
          Pagamento annullato
        </h1>
        <p className="text-sm text-zinc-500 mb-6 leading-relaxed">
          Non è stato addebitato alcun importo. Puoi riprovare quando vuoi dalla Dashboard.
        </p>
        <button onClick={() => navigate('/dashboard')} className="bg-[#C5A059] text-black px-5 py-2.5 text-xs font-medium hover:bg-[#D4B271] transition-colors" data-testid="payment-cancel-back">
          Torna alla Dashboard
        </button>
      </div>
    </div>
  );
}
